import { UploadTaskStatus } from '@fabric-app/types/upload';
import { throttle } from 'lodash-es';
import { uploadStore } from '../upload.store.js';

class UploadProgressTracker {
  constructor(taskId, onProgress) {
    this.taskId = taskId;
    this.onProgress = onProgress;
    this.throttledProgress = throttle(this.updateProgress.bind(this), 100, {
      leading: true,
      trailing: true
    });
  }
  updateProgress() {
    const store = uploadStore.getState();
    store.updateTask(this.taskId, (task) => {
      const progress = task.chunks.reduce((acc, chunk) => {
        const chunkCompletedBytes = chunk.progress / 100 * chunk.size;
        return acc + chunkCompletedBytes;
      }, 0) / task.data.file.size * 100;
      const { uploadingChunks, lastActiveChunkIndex, pendingChunks } = task.chunks.reduce((acc, chunk, index) => {
        if (chunk.status === UploadTaskStatus.Uploading) {
          acc.uploadingChunks.push(chunk);
          acc.lastActiveChunkIndex = index;
        } else if (chunk.status === UploadTaskStatus.Pending) {
          acc.pendingChunks.push(chunk);
        }
        return acc;
      }, {
        uploadingChunks: [],
        lastActiveChunkIndex: -1,
        pendingChunks: []
      });
      const uploadSpeed = uploadingChunks.reduce((acc, chunk) => acc + chunk.uploadSpeed, 0) / uploadingChunks.length;
      this.onProgress?.({
        id: this.taskId,
        overall: progress,
        chunk: lastActiveChunkIndex,
        chunkTotal: task.chunks.length,
        uploadSpeed,
        pending: pendingChunks.length > 0
      });
      return {
        ...task,
        progress,
        uploadSpeed
      };
    });
  }
  onChunkProgress(chunkIndex, progress, uploadSpeed) {
    const store = uploadStore.getState();
    store.updateChunk(this.taskId, chunkIndex, (chunk) => ({
      ...chunk,
      progress,
      uploadSpeed
    }));
    this.throttledProgress();
  }
  destroy() {
    this.throttledProgress.cancel();
  }
}

export { UploadProgressTracker };
//# sourceMappingURL=UploadProgressTracker.js.map
